
<template>
    
    <div id="panel-description" class="panel"  v-if="is_mem">
        <div class="panel-hdr bg-primary-700 bg-success-gradient">
            <h2>
                Службова  на погодження Протоколу
            </h2>
            <div class="panel-toolbar">
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-collapse" data-toggle="tooltip" data-offset="0,10" data-original-title="Collapse"></button>
                <button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen" data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>
            </div>
        </div>
        <div class="panel-container collapse show overflow-auto">
            
            <div class="panel-content">
                <a class="a_memorandum" target="_blank" :href="'https://office.imcagro.com.ua/docs/memorandum/' + this.protocol.memoramdum_protocol_id">
                    <div class="btn btn-outline-primary waves-effect waves-themed" style="width:inherit;">Переглянути</div>
                </a>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: "protocol_inside_memorandum",
    props: { protocol: { type: Object, required: true } },
    
    computed: {
        is_mem() {
            return parseInt(this.protocol.memoramdum_protocol_id) > 0;
        },
    }
}
</script>


<style scoped>

</style>